import React, { useState } from 'react';
import { DateRangePicker as ReactDateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { CalendarRange } from "lucide-react";

const DateRangePickerComponent = ({ onSelectRange }) => {
    const initialRange = {
        startDate: null,
        endDate: null,
        key: 'selection',
    };

    const [selectedRange, setSelectedRange] = useState(initialRange);
    const [displayDateRange, setDisplayDateRange] = useState(false);

    const handleSelect = (ranges) => {
        console.log('Selected Range:', ranges.selection);
        setSelectedRange(ranges.selection);
        if (ranges.selection.startDate !== null && ranges.selection.endDate !== null && ranges.selection.startDate !== ranges.selection.endDate) {
            setDisplayDateRange(false);
            onSelectRange(ranges.selection);
        }
    };

    const toggleDateRangeDisplay = () => {
        setDisplayDateRange(!displayDateRange);
    };

    // Format dates for display in the button
    const formatDate = (date) => {
        if (!date) return '';
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    // Show selected date range in button if available
    const getButtonText = () => {
        if (selectedRange.startDate && selectedRange.endDate) {
            return `${formatDate(selectedRange.startDate)} - ${formatDate(selectedRange.endDate)}`;
        }
        return "Select Date Range";
    };

    return (
        <div className="relative">
            <button
                className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm"
                onClick={toggleDateRangeDisplay}
                type="button"
            >
                <CalendarRange size={18} />
                <span className="hidden sm:inline">{getButtonText()}</span>
            </button>

            {displayDateRange && (
                <div className="absolute z-50 mt-2 right-0">
                    <div className="bg-white rounded-lg shadow-lg p-2 border border-gray-200">
                        <ReactDateRangePicker
                            ranges={[selectedRange]}
                            onChange={handleSelect}
                            months={1}
                            direction="horizontal"
                            preventSnapRefocus={true}
                            calendarFocus="backwards"
                            className="rounded-md overflow-hidden"
                            rangeColors={["#3b82f6"]} // blue-500 color
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateRangePickerComponent;